import * as tslib_1 from "tslib";
import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
import { getUserConfiguration } from 'owa-session-store';
import { lazyLoadSignatureInUserOptions } from 'owa-options-message-options';
export default select({
    editorViewState: function () { return store.editorViewState; },
    userOptions: function () { return getUserConfiguration().UserOptions; },
})(action('initializeSignatureContent')(function initializeSignatureContent(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var editorViewState, userOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    editorViewState = state.editorViewState, userOptions = state.userOptions;
                    return [4 /*yield*/, lazyLoadSignatureInUserOptions.importAndExecute()];
                case 1:
                    _a.sent();
                    editorViewState.content = userOptions.SignatureHtml;
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=initializeSignatureContent.js.map